var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"video-visualizer",attrs:{"show":_vm.show ? 'true' : 'false'}},[_c('div',{staticClass:"contenedor-video"},[_c('button',{staticClass:"cerrar",on:{"click":_vm.closeVideo}},[_vm._v("✕")]),_vm._v(" "),_c('iframe',{attrs:{"allowscriptaccess":"always","src":'https://www.youtube.com/embed/' +
          [_vm.id] +
          '?enablejsapi=1&version=3&playerapiid=ytplayer'}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f05724be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/video-visualizer.vue
// module id = null
// module chunks = 